import { getConfig } from '@gokrew/ui/runtime-config';
import { useUtmCapture } from '@gokrew/ui';
import { AppRoutes } from './routes';
import { init as sentryInit } from '@sentry/react';

function App() {
  const { ENABLE_SENTRY, ENVIRONMENT } = getConfig();
  if (ENABLE_SENTRY) {
    sentryInit({
      dsn: 'https://af5e81690aebc2ef72f871d4a2822c37@o4510754348859392.ingest.us.sentry.io/4510760005533696',
      environment: ENVIRONMENT,
      sendDefaultPii: true,
    });
  }
  useUtmCapture();
  return <AppRoutes />;
}

export default App;
